import React from "react";
import { useSelector } from "react-redux";
import * as tState from "../../reducers/toggleReducer";

interface HoverProps {
  styles?: string;
  id: string;
  message: string;
  messageHeader: string;
  position?: string;
}

export const HoverMessage: React.FC<HoverProps> = ({
  children,
  styles,
  id,
  message,
  position,
  messageHeader,
}) => {
  const style = styles
    ? styles
    : "bg-brand-white border border-gray-300 shadow-xl flex-col content-center rounded-xl bg-opacity-70 w-64 text-brand-dark_blue z-50 absolute text-center";
  const pos = position ? position : "mr-64";
  const show = useSelector(tState.getToggleState);

  return (
    <React.Fragment>
      {children}
      {show[id] ? (
        <div className={`${style} ${pos}`}>
          <div className='font-bold'>{messageHeader}</div>
          <div>{message}</div>
        </div>
      ) : null}
    </React.Fragment>
  );
};
